import { AppState } from 'store/root.reducer'

export const selectAlertsState = (state: AppState) => state?.alerts

export const selectAlerts = (state: AppState) => selectAlertsState(state).alerts

export const selectAlertsCount = (state: AppState) => selectAlertsState(state)?.count
